import { css } from 'emotion'

export const DeleteWorkspaceMainStyles = css`
  .LabelDiv {
    text-transform: none;
  }
`
